// Case Studies Data - All project information for the Case Studies feature
export const caseStudies = [
  {
    slug: 'city-of-miami-beach',
    client: 'City of Miami Beach',
    industry: 'Government',
    category: ['Creative Direction', 'Content Production', 'Social Media'],
    tagline: "Transforming one of America's biggest public safety challenges into a campaign that captured worldwide attention.",
    overview: 'The City of Miami Beach sought to fundamentally change the narrative surrounding Spring Break after years of overcrowding, public safety concerns, and ineffective awareness campaigns. The objective was to create a bold, culturally relevant campaign capable of changing visitor behavior while generating national awareness before travelers arrived.',
    challenge: 'Previous campaigns struggled to influence visitor behavior or break through the media noise surrounding Spring Break. The campaign needed to shift public perception, reach visitors before arrival, clearly communicate new safety measures, generate national conversation, and increase awareness through digital-first storytelling.',
    strategy: 'We conducted deep audience research, developed culturally resonant creative concepts, and executed a multi-platform digital campaign that reached billions of impressions across social media, digital advertising, and earned media coverage.',
    services: ['Creative Direction', 'Campaign Strategy', 'Brand Development', 'Creative Concepting', 'Photography', 'Graphic Design', 'Digital Campaign Creative', 'Social Content', 'Public Awareness Campaign'],
    results: [
      'Generated over 6.5 billion impressions across both campaigns.',
      'Drove 674K+ website visits and 123K+ link clicks for the Breakup campaign.',
      'Achieved 2 billion+ video views across platforms.',
      'Earned coverage from The New York Times, Bloomberg, NBC, Good Morning America, and international publications.',
    ],
    metrics: [
      { value: '6.5B+', label: 'Total Impressions' },
      { value: '674K+', label: 'Website Visits' },
      { value: '2B+', label: 'Video Views' },
      { value: '123K+', label: 'Link Clicks' },
    ],
    heroImage: '/images/mb-hero.webp',
    galleryImages: [
      '/images/mb-asset-1.png', '/images/mb-asset-2.png', '/images/mb-asset-3.png', '/images/mb-asset-4.png', '/images/mb-asset-5.png',
      '/images/sb-page-1.png', '/images/sb-page-4.png', '/images/sb-page-5.png', '/images/sb-page-6.png',
      '/images/sb-page-7.png', '/images/sb-page-8.png', '/images/sb-page-9.png', '/images/sb-page-10.png',
      '/images/sb-page-11.png', '/images/sb-page-12.png', '/images/sb-page-13.png', '/images/sb-page-14.png',
      '/images/sb-page-15.png', '/images/sb-page-16.png', '/images/sb-page-17.png',
      '/images/tcooc-page-1.png', '/images/tcooc-page-4.png', '/images/tcooc-page-5.png',
      '/images/tcooc-page-6.png', '/images/tcooc-page-7.png',
    ],
    flagship: true,
    featured: true,
    campaignMetrics: {
      breakup: [
        { value: '6.5B+', label: 'Impressions' },
        { value: '674K+', label: 'Website Visits' },
        { value: '123K+', label: 'Link Clicks' },
        { value: '2B+', label: 'Video Views' },
      ],
      takeCare: [
        { value: '4.3M+', label: 'Impressions' },
        { value: '17.9K', label: 'Website Visits' },
        { value: '4,091', label: 'Link Clicks' },
        { value: '200K', label: 'Video Views' },
      ],
    },
    mediaCoverage: ['The New York Times', 'Bloomberg', 'NBC', 'Good Morning America', 'Miami Herald', 'New York Post', 'Le Figaro', 'The Wall Street Journal', 'People'],
    strategyTimeline: ['Research', 'Audience Insights', 'Campaign Strategy', 'Creative Development', 'Content Production', 'Media Rollout', 'Optimization'],
  },
  {
    slug: 'art-week-miami-beach',
    client: 'Art Week Miami Beach',
    industry: 'Government',
    category: ['Creative Direction', 'Content Production', 'Social Media', 'Influencer Marketing'],
    tagline: "Bringing one of the world's most recognized art weeks to life through an integrated, citywide marketing campaign.",
    overview: 'Art Week Miami Beach required a fully integrated marketing campaign to promote Art Week 2023, including the internationally recognized No Vacancy public art program, temporary public art installations, the Art Basel Legacy Purchase initiative and citywide cultural programming. The objective was to increase awareness, drive attendance, encourage community engagement and position Miami Beach as a premier global destination for arts and culture through a coordinated multi-channel campaign.',
    challenge: 'The campaign needed to communicate multiple city initiatives simultaneously while creating excitement around Art Week, supporting public art programs and driving participation across residents and visitors.',
    strategy: 'We developed an integrated marketing strategy spanning digital advertising, social media, influencer partnerships, out-of-home placements, email marketing, experiential activations and public relations to create a unified campaign across every touchpoint.',
    services: ['Marketing Strategy', 'Creative Direction', 'Media Buying', 'Website Design', 'Campaign Branding', 'Photography', 'Video Production', 'Social Media', 'Influencer Marketing', 'Experiential Marketing', 'Digital Advertising', 'Email Marketing', 'Search Marketing', 'Out-of-Home Advertising', 'Public Relations'],
    results: [
      'Generated 7.7M+ campaign impressions across all channels.',
      'Drove 50,837 website views and 19,689 digital and social clicks.',
      'Achieved 353,983 video views across platforms.',
      'Earned 1.9B media reach across 108 media outlets.',
    ],
    metrics: [
      { value: '7.7M+', label: 'Impressions' },
      { value: '50,837', label: 'Website Views' },
      { value: '1.9B', label: 'Earned Media Reach' },
      { value: '108', label: 'Media Outlets' },
    ],
    heroImage: '/images/aw-hero.png',
    galleryImages: [
      '/images/aw-img-8.jpeg','/images/aw-img-9.jpeg','/images/aw-img-10.png',
      '/images/aw-img-12.png','/images/aw-img-14.png','/images/aw-img-22.png',
      '/images/aw-img-27.png','/images/aw-img-28.png','/images/aw-img-29.png',
      '/images/aw-img-30.png','/images/aw-img-33.png','/images/aw-img-34.png',
      '/images/aw-img-35.png','/images/aw-img-37.png',
      '/images/aw-img-48.png','/images/aw-img-49.png','/images/aw-img-50.png',
      '/images/aw-img-51.png','/images/aw-img-54.png','/images/aw-img-55.png','/images/aw-img-56.png',
      '/images/aw-img-57.png','/images/aw-img-59.png','/images/aw-img-60.png','/images/aw-img-61.png',
      '/images/aw-img-62.png','/images/aw-img-63.png','/images/aw-img-64.png','/images/aw-img-79.jpeg',
      '/images/aw-img-80.jpeg','/images/aw-img-81.jpeg','/images/aw-img-82.jpeg','/images/aw-img-91.png',
      '/images/aw-img-96.jpeg','/images/aw-img-97.jpeg','/images/aw-img-98.jpeg','/images/aw-img-99.jpeg',
      '/images/aw-img-100.jpeg','/images/aw-img-101.jpeg','/images/aw-img-102.jpeg','/images/aw-img-103.jpeg',
      '/images/aw-img-104.jpeg','/images/aw-img-105.jpeg','/images/aw-img-106.jpeg','/images/aw-img-107.jpeg',
      '/images/aw-img-108.jpeg','/images/aw-img-109.jpeg',
    ],
    flagship: false,
    featured: true,
  },
  {
    slug: 'find-your-wave',
    client: 'Find Your Wave',
    industry: 'Government',
    category: ['Creative Direction', 'Content Production', 'Social Media'],
    tagline: 'Repositioning Miami Beach beyond the beach through an integrated destination marketing campaign.',
    overview: 'The Find Your Wave campaign was created to reposition Miami Beach as far more than a beach destination by highlighting its arts and culture, culinary scene, wellness experiences, business community, architecture and year-round lifestyle.',
    challenge: 'Research identified an opportunity to broaden public perception of Miami Beach beyond beaches alone. The campaign needed to diversify tourism, strengthen brand perception and encourage residents, visitors and meeting planners to experience every dimension of Miami Beach.',
    strategy: 'We developed an integrated destination marketing campaign centered around four brand pillars — Quality of Life, Urban Oasis, Culture Capital, and World-Class Experiences — deployed across digital, social, OOH, print, video, SEM and experiential channels.',
    services: ['Brand Strategy', 'Creative Direction', 'Destination Marketing', 'Campaign Development', 'Digital Advertising', 'Social Media', 'Video Production', 'Photography', 'Media Buying', 'Out-of-Home Advertising', 'Search Marketing', 'Print Design', 'Website Creative'],
    results: [
      'Generated 65.8 million+ campaign impressions.',
      'Achieved 6.5 million+ video plays across platforms.',
      'Drove 251,431 digital link clicks.',
      'Attributed 18,995 hotel bookings to the campaign.',
    ],
    metrics: [
      { value: '65.8M+', label: 'Impressions' },
      { value: '6.5M+', label: 'Video Plays' },
      { value: '251,431', label: 'Link Clicks' },
      { value: '18,995', label: 'Hotel Bookings' },
    ],
    heroImage: '/images/fyw-img-1.jpeg',
    galleryImages: [
      '/images/fyw-img-2.png','/images/fyw-img-3.png','/images/fyw-img-4.png','/images/fyw-img-5.png',
      '/images/fyw-img-6.png','/images/fyw-img-7.png','/images/fyw-img-8.png','/images/fyw-img-9.png',
      '/images/fyw-img-10.png','/images/fyw-img-11.png','/images/fyw-img-12.png','/images/fyw-img-13.png',
      '/images/fyw-img-14.png','/images/fyw-img-15.png','/images/fyw-img-16.png','/images/fyw-img-17.png',
      '/images/fyw-img-18.png','/images/fyw-img-19.png','/images/fyw-img-20.png','/images/fyw-img-21.png',
      '/images/fyw-img-22.jpeg','/images/fyw-img-23.png','/images/fyw-img-24.png','/images/fyw-img-25.png',
      '/images/fyw-img-26.png','/images/fyw-img-27.png','/images/fyw-img-28.jpeg',
      '/images/fyw-page-1.png','/images/fyw-page-3.png','/images/fyw-page-4.png','/images/fyw-page-5.png',
      '/images/fyw-page-6.png','/images/fyw-page-7.png','/images/fyw-page-8.png','/images/fyw-page-9.png',
      '/images/fyw-page-10.png',
    ],
    flagship: false,
    featured: true,
  },
  {
    slug: 'aroma360',
    client: 'Hotel Collection (Aroma360)',
    industry: 'Luxury Brands',
    category: ['Influencer Marketing', 'Creative Direction', 'Content Production'],
    tagline: 'Global influencer campaigns driving $175K+ in trackable revenue.',
    overview: 'Aroma360 expanded influencer marketing across the U.S., Canada, United Kingdom and Dubai through strategic creator partnerships designed to increase awareness, revenue and luxury positioning.',
    challenge: 'Scaling influencer marketing globally while maintaining luxury brand positioning and ensuring measurable return on every dollar spent across multiple markets and creator partnerships.',
    strategy: 'We sourced creators aligned with the brand\'s luxury aesthetic, managed end-to-end campaigns across four global markets, and collaborated with paid media teams to maximize ROI through data-driven optimization.',
    services: ['Influencer Marketing Strategy', 'Creator Sourcing & Management', 'Campaign Execution', 'Global Market Expansion', 'Performance Analytics', 'Paid Media Collaboration'],
    results: [
      'Generated over $175K+ in trackable revenue from influencer content.',
      'Expanded brand presence across U.S., Canada, U.K. and Dubai.',
      'Drove measurable return through data-driven influencer spend.',
      'Elevated brand recognition with luxury-focused, conversion-driven content.',
    ],
    metrics: [
      { value: '$175K+', label: 'Trackable Revenue' },
      { value: '10.48', label: 'Highest ROAS' },
      { value: '4', label: 'Global Markets' },
    ],
    globalMarkets: ['U.S.', 'Canada', 'U.K.', 'Dubai'],
    heroImage: '/images/hc-hero.jpg',
    galleryImages: ['/images/hc-gallery-1.jpg'],
    videos: ['/images/hc-vid-1.mp4', '/images/hc-vid-2.mp4', '/images/hc-vid-3.mp4', '/images/hc-vid-4.mp4', '/images/hc-vid-5.mp4', '/images/hc-vid-6.mp4', '/images/hc-vid-7.mp4', '/images/hc-vid-8.mp4'],
    featured: true,
  },
  {
    slug: 'khadija-hallouty',
    client: 'Khadija Hallouty',
    industry: 'Lifestyle',
    category: ['Personal Brands', 'Creative Direction', 'Content Production'],
    tagline: 'Content creator scaling across beauty, fashion and travel.',
    overview: 'Khadija Hallouty is a content creator specializing in beauty, fashion and travel. We consulted on brand strategy, content direction and growth tactics to help scale her digital presence and attract premium brand partnerships.',
    challenge: 'Creating a cohesive multi-niche personal brand that could attract premium partnerships across beauty, fashion and travel without diluting the core identity.',
    strategy: 'We focused on defining content pillars that bridged her interests, optimizing her visual identity for consistency, and building engagement strategies that attracted brand attention.',
    services: ['Personal Branding', 'Content Strategy', 'Visual Identity', 'Caption Optimization', 'Growth Tactics'],
    results: [
      'Strengthened multi-niche brand identity.',
      'Secured premium brand collaborations.',
      'Built consistent, recognizable content style.',
    ],
    metrics: [],
    heroImage: '/images/khadija-hero.jpg',
    galleryImages: ['/images/khadija-2.jpg', '/images/khadija-3.jpg', '/images/khadija-4.jpg', '/images/khadija-5.jpg', '/images/khadija-6.jpg', '/images/khadija-7.jpg', '/images/khadija-8.jpg', '/images/khadija-9.jpg', '/images/khadija-10.webp', '/images/khadija-11.webp', '/images/khadija-12.webp'],
    videos: ['/images/khadija-vid-1.mp4', '/images/khadija-vid-2.mp4', '/images/khadija-vid-3.mp4', '/images/khadija-vid-4.mp4', '/images/khadija-vid-5.mp4', '/images/khadija-vid-6.mp4'],
    featured: false,
  },
  {
    slug: 'empower-her',
    client: 'Empower Her',
    industry: 'Wellness',
    category: ['Social Media', 'Content Production', 'Event Coverage'],
    tagline: 'Growing a wellness community through strategy, storytelling and events.',
    overview: 'Empower Her focused on growing a wellness community through strategic storytelling, educational content, live event coverage and social-first marketing.',
    challenge: 'Building trust and visibility for a women-led wellness platform in a crowded wellness market, while driving real-world event attendance through digital-first strategies.',
    strategy: 'We directed social strategy across Instagram and email, designed content calendars around events and partnerships, produced high-performing visual content, and cultivated a loyal community through intentional storytelling.',
    services: ['Social Strategy', 'Content Calendars', 'Video & Visual Production', 'Event Coverage', 'Community Building', 'Email Campaigns', 'Brand Voice Development'],
    results: [
      'Grew social media audience by over 60% within the first year.',
      'Increased event ticket sales through targeted, emotionally resonant content.',
      'Strengthened brand recognition through strategic partnerships.',
      'Elevated community engagement and event turnout.',
    ],
    metrics: [
      { value: '60%+', label: 'Community Growth' },
      { value: '2x', label: 'Event Attendance' },
      { value: '3x', label: 'Engagement Rate' },
    ],
    heroImage: '/images/empowerher-9.jpg',
    galleryImages: ['/images/empowerher-hero.jpg', '/images/empowerher-2.jpg', '/images/empowerher-3.jpg', '/images/empowerher-4.jpg', '/images/empowerher-5.jpg', '/images/empowerher-6.jpg', '/images/empowerher-7.jpg', '/images/empowerher-8.jpg', '/images/empowerher-10.jpg'],
    videos: ['/images/empowerher-vid-1.mp4', '/images/empowerher-vid-2.mp4', '/images/empowerher-vid-3.mp4', '/images/empowerher-vid-4.mp4'],
    featured: true,
  },
  {
    slug: 'sterling-equity-realty',
    client: 'Sterling Equity Realty',
    industry: 'Real Estate',
    category: ['Social Media', 'Creative Direction', 'Photography'],
    tagline: "Miami's premier boutique brokerage, elevated digitally.",
    overview: "Sterling Equity Realty is Miami's premier full-service boutique brokerage specializing in residential and commercial properties, business brokerage, and real estate consulting. We built a cohesive digital presence that reflected the brand's luxury positioning.",
    challenge: 'Creating a social media presence that communicated luxury and expertise in a competitive Miami real estate market.',
    strategy: 'We audited existing platforms, created a personalized strategy, produced original photo and video content, and designed a cohesive branded feed reflecting the brokerage\'s premium voice.',
    services: ['Platform Audit', 'Social Media Strategy', 'Content Production', 'Photography', 'Branded Feed Design', 'Analytics'],
    results: [
      'Increased brand visibility and local reach.',
      'Designed a cohesive, branded feed reflecting luxury positioning.',
      'Strengthened digital credibility in the Miami market.',
    ],
    metrics: [],
    heroImage: '/images/sterling-hero.jpg',
    galleryImages: ['/images/sterling-gallery-1.webp'],
    videos: ['/images/sterling-vid-1.mp4', '/images/sterling-vid-2.mp4'],
    featured: false,
  },
  {
    slug: 'agent-sterling-miami',
    client: 'Agent Sterling Miami',
    industry: 'Real Estate',
    category: ['Personal Brands', 'Social Media', 'Content Production'],
    tagline: 'Empowering real estate agents through digital brand building.',
    overview: 'Agent Sterling Miami helps manage and empower independent real estate agents through broker management processes and virtual closing technology. We developed their social presence to attract and retain top talent.',
    challenge: 'Positioning a real estate platform as both a professional resource and an aspirational brand in a competitive talent acquisition market.',
    strategy: 'We created content pillars around tips, recruitment and community, producing branded visuals and engagement strategies that attracted quality agents.',
    services: ['Social Media Strategy', 'Content Production', 'Personal Branding', 'Engagement Strategy'],
    results: [
      'Grew follower base and local engagement.',
      'Attracted quality agent applications through content.',
      'Established a recognizable brand voice.',
    ],
    metrics: [],
    heroImage: '/images/agentsterling-hero.jpg',
    galleryImages: ['/images/agentsterling-gallery-1.webp', '/images/agentsterling-gallery-2.webp'],
    videos: ['/images/agentsterling-vid-1.mp4', '/images/agentsterling-vid-2.mp4'],
    featured: false,
  },
  {
    slug: 'aude-swim',
    client: 'Aude Swim',
    industry: 'Fashion',
    category: ['Photography'],
    tagline: 'Photography that performed — a retrospective analysis of measurable Instagram engagement.',
    overview: 'Between 2020 and 2023, Muse Social Creative photographed multiple campaigns for Aude Swim. This case study reviews the publicly visible Instagram performance of those published photographs, highlighting measurable engagement across 50 photo posts.',
    challenge: 'Documenting the publicly visible engagement metrics of campaign photography to provide a transparent, data-driven look at how the imagery performed once published.',
    strategy: 'Rather than relying on opinions, this case study focuses on measurable performance by reviewing every published Instagram photo post featuring Muse photography.',
    services: ['Photography'],
    results: [
      '50 published photo posts reviewed.',
      'Highest-performing photo earned 3,429 likes and 36 comments.',
      'Total visible photo likes reached 23,800 across 50 posts.',
      'Average of 517 likes per published photograph.',
    ],
    metrics: [
      { value: '50', label: 'Photos Reviewed' },
      { value: '3,429', label: 'Highest Photo Likes' },
      { value: '23,800', label: 'Total Photo Likes' },
      { value: '517', label: 'Avg Likes Per Photo' },
    ],
    heroImage: '/images/aude-post-9.jpg',
    galleryImages: [],
    flagship: true,
    featured: true,
  },
];

export const filterCategories = [
  'All',
  'Social Media',
  'Creative Direction',
  'Photography',
  'Video Production',
  'Content Production',
  'Event Coverage',
  'Influencer Marketing',
  'Personal Brands',
  'Luxury Brands',
  'Real Estate',
  'Wellness',
  'Beauty',
  'Fashion',
];

export const processSteps = [
  { num: '01', title: 'Discover', desc: 'Deep-dive into brand, audience, competitors and goals.' },
  { num: '02', title: 'Strategy', desc: 'Build the roadmap that connects vision to execution.' },
  { num: '03', title: 'Create', desc: 'Produce content, campaigns and creative assets.' },
  { num: '04', title: 'Launch', desc: 'Execute across platforms with precision and intention.' },
  { num: '05', title: 'Optimize', desc: 'Analyze, refine and scale what works.' },
];

export const stats = [
  { value: 50, suffix: '+', label: 'Projects Completed' },
  { value: 30, suffix: '+', label: 'Brands Served' },
  { value: 10, suffix: 'K+', label: 'Content Produced' },
  { value: 100, suffix: '+', label: 'Campaigns Executed' },
  { value: 4, suffix: '', label: 'Countries Worked In' },
];
